import { render, staticRenderFns } from "./Atenciones.vue?vue&type=template&id=02fb0816&"
import script from "./Atenciones.vue?vue&type=script&lang=js&"
export * from "./Atenciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports